
import React from 'react';
import { Mail, AlertCircle, Download, Info } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface EmailErrorAlertProps {
  retryEmailSending: () => Promise<void>;
  downloadQRCode: () => void;
}

const EmailErrorAlert: React.FC<EmailErrorAlertProps> = ({ 
  retryEmailSending, 
  downloadQRCode 
}) => {
  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Không thể gửi email xác nhận</AlertTitle>
      <AlertDescription className="space-y-3">
        <div className="flex items-start gap-2 mt-2">
          <Info className="h-4 w-4 text-yellow-500 flex-shrink-0 mt-0.5" />
          <p className="text-sm">
            Hệ thống đã thử gửi email nhiều lần nhưng không thành công. 
            Bạn vẫn có thể tham dự họp mặt. Vui lòng lưu lại mã QR để sử dụng khi điểm danh.
          </p>
        </div>
        
        <div className="flex flex-wrap gap-2 mt-3">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={retryEmailSending}
            className="flex items-center gap-1"
          >
            <Mail className="h-3.5 w-3.5" />
            Thử gửi lại
          </Button>
          
          <Button
            variant="default"
            size="sm"
            onClick={downloadQRCode}
            className="bg-blue-600 hover:bg-blue-700 flex items-center gap-1"
          >
            <Download className="h-3.5 w-3.5" />
            Tải mã QR
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
};

export default EmailErrorAlert;
